// Auto generated file, do not manually modify!
// com.hotpads.adproducts.api.web.user.billing.handler.AdproductsUserBillingContactApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AdManagementBillingContactDto } from '../..';

interface GetBillingContactParams {
  accountNumber: string;
}

export const AdproductsUserBillingContactApiHandler_getBillingContact_Path =
  '/api/web/v1/users/billing/contacts/getBillingContact';

/**
 * Get billing contact details for logged-in user and account
 */
export const AdproductsUserBillingContactApiHandler_getBillingContact = (
  getParams: GetBillingContactParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetBillingContactParams, never, AdManagementBillingContactDto>(
    {
      getParams: getParams,
      endpoint: AdproductsUserBillingContactApiHandler_getBillingContact_Path,
      method: 'GET',
      contextPath: '/adproducts',
    },
    client,
  );
};

export const AdproductsUserBillingContactApiHandler_saveBillingContact_Path =
  '/api/web/v1/users/billing/contacts/saveBillingContact';

/**
 * Save billing contact details for logged-in user and account
 */
export const AdproductsUserBillingContactApiHandler_saveBillingContact = (
  postData: AdManagementBillingContactDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AdManagementBillingContactDto, void>(
    {
      endpoint: AdproductsUserBillingContactApiHandler_saveBillingContact_Path,
      method: 'POST',
      contextPath: '/adproducts',
      postData: postData,
    },
    client,
  );
};
